import { useAuthStore } from '../store/authStore';

export function useShowAds(): boolean {
  const user = useAuthStore((state) => state.user);
  if (import.meta.env.DEV) return true; // Temporarily enabled for testing
  // Show ads to unauthenticated users and free-tier subscribers
  return !user || user.subscription === 'free';
}
